import { h, Fragment } from 'preact';
import Alert from '../../../components/Alert';

export default function ConfigurationStatusMessage({
  services = [],
  minimumNotMet = false,
  usesPricing = false
}) {
  const incompleteCount = services.filter(s => !s.isComplete).length;
  const isComplete = incompleteCount === 0 && !minimumNotMet;

  const alertType = isComplete ? 'success' : 'warning';
  const title = isComplete
    ? 'All services configured!'
    : 'Please complete the following before continuing:';

  return (
    <Alert type={alertType} title={title} leftAccent>
      <ul className="m-0 space-y-1">
        {services.map((service) => (
          <li key={service.name} className="flex items-center gap-2">
            {service.isComplete ? (
              <svg className="h-5 w-5 text-green-600 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            ) : (
              <span className="h-5 w-5 shrink-0 flex items-center justify-center">
                <span className="h-2 w-2 rounded-full bg-current" />
              </span>
            )}
            <span className={service.isComplete ? 'line-through opacity-60' : ''}>
              <strong>{service.name}</strong>
              {!service.isComplete && (
                <>
                  {' '}
                  <a
                    href={`#service-${service.name.replace(/\s+/g, "-").toLowerCase()}`}
                    className="text-coit-primary hover:underline"
                  >
                    Jump To Section
                  </a>
                </>
              )}
            </span>
          </li>
        ))}
        {minimumNotMet && usesPricing && (
          <li className="flex items-center gap-2">
            <span className="h-5 w-5 shrink-0 flex items-center justify-center">
              <span className="h-2 w-2 rounded-full bg-current" />
            </span>
            <span>Meet the minimum order amount requirement</span>
          </li>
        )}
      </ul>
    </Alert>
  );
}
